
import * as React from "react"
import * as ProgressPrimitive from "@radix-ui/react-progress"

import { cn } from "@/lib/utils"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    indicatorClassName?: string;
    variant?: "default" | "prominent";
  }
>(({ className, value, indicatorClassName, variant = "default", ...props }, ref) => {
  const isProminent = variant === "prominent";
  
  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(
        "relative overflow-hidden rounded-full bg-secondary",
        isProminent ? "h-6 w-full" : "h-4 w-full",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(
          "h-full w-full flex-1 transition-all duration-300",
          isProminent ? "bg-primary flex items-center justify-center" : "bg-primary",
          indicatorClassName
        )}
        style={{ 
          transform: `translateX(-${100 - (value || 0)}%)`,
          willChange: "transform" 
        }}
      >
        {isProminent && (
          <span className="text-xs font-medium text-white">
            {Math.round(value || 0)}%
          </span>
        )}
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  )
})
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
